import { ajaxJson } from "../../imports/ajax";
import { map2programObj, map2TeacherObj } from "imports/mapper";
import { createTypes } from "redux-create-types";
import { teacherActionCreators } from "../../db/teacher/teacher.action";
import { programActionCreators } from "../../db/program/program.action";
import history from "imports/history";

const namespace = "page-home";

export const homePageActions = createTypes(
    ["toggleSpinner", "setError", "setActiveProgramId"],
    namespace
);

function setActiveProgramId(id) {
    return dispatch => {
        dispatch({
            type: homePageActions.setActiveProgramId,
            payload: id
        });
    };
}

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: homePageActions.toggleSpinner,
            payload: true,
            meta: { apiName }
        });
    };
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: homePageActions.toggleSpinner,
            payload: false,
            meta: { apiName }
        });
    };
}

function getFeatureTeachersApiSuccess(res) {
    return dispatch => {
        res.data.forEach(teacher => {
            teacher["is_featured"] = true;
            const teacherObj = map2TeacherObj(teacher);
            dispatch(teacherActionCreators.save(teacherObj));
        });
    };
}

function getFeatureTeachersApiFail(err) {
    return dispatch => {
        dispatch({
            type: homePageActions.setError,
            payload: err
        });
        return dispatch(hideSpinner("teachers"));
    };
}

function getFeatureTeachersFromApi() {
    return dispatch => {
        dispatch(showSpinner("teachers"));
        return ajaxJson
            .get("/lecturers", {
                params: {
                    is_featured: true
                }
            })
            .then(
                res => dispatch(getFeatureTeachersApiSuccess(res)),
                err => dispatch(getFeatureTeachersApiFail(err))
            )
            .then(() => {
                return dispatch(hideSpinner("teachers"));
            });
    };
}

function getActiveProgramApiSuccess(res) {
    return dispatch => {
        const programObj = map2programObj(res.data);
        dispatch(setActiveProgramId(programObj.id));
        dispatch(programActionCreators.save(programObj));
    };
}

function getActiveProgramApiFail(err) {
    return dispatch => {
        dispatch({
            type: homePageActions.setError,
            payload: err
        });
        return dispatch(hideSpinner("program"));
    };
}

function getActiveProgramFromApi() {
    return dispatch => {
        dispatch(showSpinner("program"));
        return ajaxJson
            .get(`/programs/active`)
            .then(
                res => dispatch(getActiveProgramApiSuccess(res)),
                err => dispatch(getActiveProgramApiFail(err))
            )
            .then(() => {
                return dispatch(hideSpinner("program"));
            });
    };
}

function buyProgram(programId) {
    return dispatch => {
        history.push(`/enrollment/${programId}`);
    };
}

function buyActiveProgram() {
    return dispatch => {
        return ajaxJson.get(`/programs/active`).then(activeProgramRes => {
            const id = activeProgramRes.data["uid"];
            history.push(`/enrollment/${id}`);
        });
    };
}



export const homePageActionsCreator = {
    getFeatureTeachersFromApi,
    getActiveProgramFromApi,
    buyActiveProgram,
    buyProgram
};
